import { useLocation } from 'react-router-dom'
import { GuideNavigationChapterData } from '../data/GuideNavigationChapterData'

export const useGetCurrentStep = (chapters: GuideNavigationChapterData[]) => {
  const { pathname } = useLocation()

  return chapters
    .flatMap((chapter) => chapter.steps)
    .find((step) => pathname.includes(step.link))
}
